export default "__VITE_PUBLIC_ASSET__559fcbe6__"